
export default [
    {
        path: '/app/profile',
        name: 'app.profile',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-profile" */ './../views/App/Profile/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    }
]
